import React from 'react';
import { Avatar } from 'antd';

export default function NameAvatar({ display_name }) {
  const nameParts = (display_name || 'No Name').split(' ');
  const firstName = getFirstLetter(nameParts[0]);
  const lastName = getFirstLetter(nameParts[nameParts.length - 1]);
  const namedColor = colorLetterMap[firstName[0].toLowerCase()];
  return (
    <Avatar size={43} style={{ paddingTop: 2, backgroundColor: namedColor }}>
      {firstName}
      {lastName}
    </Avatar>
  );
}

const getFirstLetter = name => (name ? name[0] || '' : '');

const colors = [
  '#6B106F',
  '#0E48A2',
  '#0A834E',
  '#952763',
  '#9FA817',
  '#CF722E',
  '#58B43D',
  '#2883CA',
  '#753ED4',
  '#CC304D',
];

const letters = 'abcdefghijklmnopqrstuvwxyz';

const colorLetterMap = {};

for (let i = 0; i < 26; i++)
  colorLetterMap[letters[i]] = colors[i % colors.length];
